import { useMemo, useState } from "react";

import { Literals, Source } from "shared/types";
import classNames from "shared/utils/classNames";
import { getSourceName } from "shared/utils/sourceUtils";

import "./index.css";

const onlyUnique = (value: string, index: number, array: string[]) =>
  array.indexOf(value) === index;

type Props = {
  sources: Source[] | undefined;
  copyTexts: Literals;
};

function Sources(props: Props) {
  const { sources, copyTexts } = props;

  const uniqueSources = useMemo(
    () => sources?.map(({ url }) => url).filter(onlyUnique),
    [sources],
  );
  const [sourcesOpen, setSourcesOpen] = useState(false);

  if (!Array.isArray(uniqueSources) || !uniqueSources.length) {
    return null;
  }

  return (
    <div className="pt-2">
      <div
        className="sources text-secondary"
        onClick={() => setSourcesOpen(!sourcesOpen)}
      >
        <i className={classNames("arrow", sourcesOpen && "arrow-down")} />
        <span>{copyTexts.sourcesText}</span>
      </div>
      {sourcesOpen && (
        <div className="source-grid">
          {uniqueSources.map((url, index) => (
            <a
              key={url}
              href={url}
              className="flex text-[#6b7280] no-underline hover:text-accent active:text-active-link"
              target="_blank"
              rel="noreferrer"
            >
              <div className="source-grid-number">{index + 1}.&nbsp;</div>
              <div className="truncate">{getSourceName(url)}</div>
            </a>
          ))}
        </div>
      )}
    </div>
  );
}

export default Sources;
